export default "__VITE_ASSET__CZUVh_hd__"